import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { RefreshCw, Check, AlertCircle } from 'lucide-react';

export const LimpiarCache = () => {
    const [steps, setSteps] = useState({
        sw_unregister: 'pending',
        caches_clear: 'pending',
        local_clear: 'pending',
        done: false
    });

    useEffect(() => {
        (async () => {
            // 1. Desregistrar TODOS los Service Workers
            try {
                if ('serviceWorker' in navigator) {
                    const regs = await navigator.serviceWorker.getRegistrations();
                    await Promise.all(regs.map((r) => r.unregister()));
                }
                setSteps((s) => ({ ...s, sw_unregister: 'ok' }));
            } catch (e) {
                setSteps((s) => ({ ...s, sw_unregister: 'fail' }));
            }

            // 2. Borrar TODOS los caches
            try {
                if ('caches' in window) {
                    const names = await caches.keys();
                    await Promise.all(names.map((n) => caches.delete(n)));
                }
                setSteps((s) => ({ ...s, caches_clear: 'ok' }));
            } catch (e) {
                setSteps((s) => ({ ...s, caches_clear: 'fail' }));
            }

            // 3. Limpiar localStorage de claves del app (NO toca la sesion del admin)
            try {
                const keysToKeep = ['token', 'auth_token']; // mantener login
                const all = Object.keys(localStorage);
                for (const k of all) {
                    if (!keysToKeep.some((keep) => k.includes(keep))) {
                        localStorage.removeItem(k);
                    }
                }
                setSteps((s) => ({ ...s, local_clear: 'ok' }));
            } catch (e) {
                setSteps((s) => ({ ...s, local_clear: 'fail' }));
            }

            setSteps((s) => ({ ...s, done: true }));
        })();
    }, []);

    const goFresh = () => {
        // Recargar con cache-bust
        const url = `/tienda?_=${Date.now()}`;
        window.location.replace(url);
    };

    const Icon = ({ status }) => {
        if (status === 'ok') return <Check className="w-5 h-5 text-emerald-500" />;
        if (status === 'fail') return <AlertCircle className="w-5 h-5 text-red-500" />;
        return <RefreshCw className="w-5 h-5 text-zinc-500 animate-spin" />;
    };

    return (
        <div className="min-h-screen bg-zinc-50 flex items-center justify-center p-4">
            <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-6">
                <h1 className="text-xl font-bold mb-1 text-zinc-900">Limpiando cache de la app</h1>
                <p className="text-xs text-zinc-500 mb-5">Forzando la version mas reciente del sitio.</p>

                <div className="space-y-3 mb-6">
                    <div className="flex items-center gap-3 text-sm">
                        <Icon status={steps.sw_unregister} />
                        <span>Desregistrando Service Worker</span>
                    </div>
                    <div className="flex items-center gap-3 text-sm">
                        <Icon status={steps.caches_clear} />
                        <span>Borrando archivos cacheados</span>
                    </div>
                    <div className="flex items-center gap-3 text-sm">
                        <Icon status={steps.local_clear} />
                        <span>Limpiando datos locales</span>
                    </div>
                </div>

                {steps.done && (
                    <div className="space-y-3">
                        <div className="p-3 bg-emerald-50 border border-emerald-200 rounded-lg text-sm text-emerald-800">
                            ✓ Listo! Toca el boton para entrar con la version mas reciente.
                        </div>
                        <button
                            onClick={goFresh}
                            className="w-full px-4 py-3 bg-amber-500 hover:bg-amber-600 text-zinc-900 font-bold rounded-lg flex items-center justify-center gap-2"
                            data-testid="btn-go-fresh"
                        >
                            <RefreshCw className="w-4 h-4" /> Entrar a la tienda
                        </button>
                        <Link to="/" className="block text-center text-xs text-zinc-500 hover:text-amber-600 mt-2">
                            ← Ir al inicio (admin)
                        </Link>
                    </div>
                )}

                <p className="text-[10px] text-zinc-400 text-center mt-6 font-mono">App version: kj-v26</p>
            </div>
        </div>
    );
};

export default LimpiarCache;
